/**
 * Per-shop points label (migration 040). Same points balance everywhere —
 * only the WORD changes per shop (BEANS → SNAGS/CRUMBS...). Display is
 * always uppercase; storage is as-entered.
 */
export function currencyLabel(shop?: { currency_name?: string | null } | null): string {
  const name = shop?.currency_name?.trim();
  return name ? name.toUpperCase() : 'BEANS';
}
